import React from 'react';
type LineItem = {
  label: string;
  detail: string;
  value: string;
};
const groups: {
  title: string;
  subtotal: string;
  items: LineItem[];
}[] = [{
  title: 'One off build',
  subtotal: '€53,000',
  items: [{
    label: 'Anzupgo core snakification',
    detail: 'Master brand build, reused by every market',
    value: '€27,000'
  }, {
    label: 'EU5 web localization',
    detail: '5 markets × €2,000',
    value: '€10,000'
  }, {
    label: '2 Master Snak campaigns',
    detail: 'Central creative build, €3,000 each',
    value: '€6,000'
  }, {
    label: 'Local campaign adaptation',
    detail: '2 campaigns × 5 markets × €1,000',
    value: '€10,000'
  }]
}, {
  title: 'Platform & year one activation',
  subtotal: '€59,900',
  items: [{
    label: 'Control Tower, localized setup',
    detail: '12-month license and governance hub',
    value: '€50,000'
  }, {
    label: 'Campaign activation',
    detail: '10 campaign markets × €99 × 10 live months',
    value: '€9,900'
  }]
}];
export function OptionBDetail() {
  return <div data-id="element-92" data-mp="m7437z25ehp4">
      <p className="text-[clamp(0.95rem,1.3vw,1.3rem)] font-semibold leading-snug text-[var(--fg)]" data-id="element-93" data-mp="m7dwbvihp4z1">
        1 brand and 2 Master Campaigns across 5 EU5 markets, with a localized
        Control Tower setup. Fixes website engagement and bounce rate now, while
        the redesign runs in parallel.
      </p>

      {groups.map(group => <div key={group.title} className="mt-5" data-id="element-94" data-mp="1iyph3862boww">
          <div className="flex items-baseline justify-between border-b border-black/10 pb-2" data-id="element-95" data-mp="155ztx0essdy7">
            <p className="text-[clamp(0.7rem,0.9vw,0.9rem)] font-bold uppercase tracking-wider text-[var(--brand-green)]" data-id="element-96" data-mp="1a3huo3invmv4">
              {group.title}
            </p>
            <span className="text-[clamp(0.8rem,1vw,1rem)] font-bold text-[var(--brand-green)]" data-id="element-97" data-mp="22klutf1242o3">
              {group.subtotal}
            </span>
          </div>
          {group.items.map(item => <div key={item.label} className="flex items-baseline justify-between gap-6 border-b border-black/5 py-3 last:border-b-0" data-id="element-98" data-mp="27hhs36h23d2w">
              <div data-id="element-99" data-mp="22khod27oimey">
                <p className="text-[clamp(0.85rem,1.05vw,1.05rem)] font-semibold leading-tight text-[var(--fg)]" data-id="element-100" data-mp="1xjbsiviq2j17">
                  {item.label}
                </p>
                <p className="text-[clamp(0.72rem,0.9vw,0.9rem)] leading-tight text-[var(--muted)]" data-id="element-101" data-mp="1tj1csr54oe95">
                  {item.detail}
                </p>
              </div>
              <span className="flex-shrink-0 text-[clamp(1rem,1.4vw,1.4rem)] font-bold leading-none text-[var(--fg)]" data-id="element-102" data-mp="1jsykkt5tz4bv">
                {item.value}
              </span>
            </div>)}
        </div>)}

      <div className="mt-5 flex items-center justify-between gap-6 rounded-2xl bg-[var(--brand-green)] px-6 py-4 text-white" data-id="element-103" data-mp="19t7rmvwx4xdw">
        <div data-id="element-104" data-mp="15ui4ibm2w1h2">
          <p className="text-[clamp(0.7rem,0.9vw,0.9rem)] font-bold uppercase tracking-wider text-[var(--brand-green-lighter)]" data-id="element-105" data-mp="3hfhih38tht7j">
            Estimated total, year one
          </p>
          <p className="mt-1 text-[clamp(0.78rem,0.95vw,0.95rem)] text-white/70" data-id="element-106" data-mp="3lixga2wmhzlt">
            Reduces immediate budget friction while establishing the core 2027
            infrastructure.
          </p>
        </div>
        <p className="flex-shrink-0 text-[clamp(1.6rem,2.6vw,2.6rem)] font-bold leading-none" data-id="element-107" data-mp="2xri65nylue00">
          €112,900
        </p>
      </div>
    </div>;
}